export const $e = {
    system: {
        booted: true,

        needs: {
            approval: true,
            reload: true,
            configReload: true,
            notificationPermission: true,
            notificationCount: true,
            tour: true,
            pin: true,
        },

        has: {
            notificationPermission: true,
            notification: true,
            confirmation: true,
        },
    },

    echo: {
        OrderStatusChanged: true,
        OrderUpdated: true,
        OrderConfirmed: true,
        OrderCancelled: true,
    },

    app: {
        loaded: true,
        loadFailed: true,
        reloaded: true,

        mainActionPrompt: {
            shown: true,
            hidden: true,
        },

        indicator: {
            process: {
                start: true,
                end: true,
            },
        },

        needs: {
            search: true,
            mainActionPrompt: true,
            orderOptions: true,

            to: {
                scrollToTop: true,
                askForPermission: true,
                closeMainActionPrompt: true,
            },
        },

        has: {
            noDeliveriesMessage: true,
            searchQuery: true,
            searchInputClick: true,
            searchCharacter: true,
        },

        messages: {
            noUserToSuggest: true,
            noBusinessToSuggest: true,
            noRelatedProducts: true,
            relatedProductsFound: true,
        },
    },

    ui: {
        not: {
            need: {
                actionsForm: true,
            },
        },

        needs: {
            offcanvas: {
                nav: true,
                productList: true,
                addressList: true,
            },
            loginForm: true,
            actionsForm: true,
            purchaseView: true,
        },
    },

    business: {
        numbersStored: true,
        scheduleStored: true,

        needs: {
            additionalPhoneNumbers: true,
            phoneNumbersForm: true,
            schedule: true,
            scheduleForm: true,
            location: true,

            to: {
                storePhoneNumbers: true,
                storeSchedule: true,
            },

            has: {
                storageError: true,
                deletionError: true,
            },
        },
        has: {
            numbersStorageError: true,
            scheduleStorageError: true,
        },
    },

    user: {
        authenticated: true,
        loggedOut: true,
        updated: true,

        needs: {
            update: true,
            temporaryAvr: true,
            quickUpdate: true,
            fcmTokenUpdate: true,
            addressForm: true,
            authentication: true,
            registration: true,
            emailLogin: true,
            googleLogin: true,
            logout: true,
            information: true,
            otherUserInformation: true,
            toFollow: true,
            toUnfollow: true,
            toBlock: true,
            toUnblock: true,
            to: {
                seePin: true,
                change: {
                    onlineStatus: true,
                },
                orderViaChat: true,
            },

            password: {
                reset: true,
                link: true,
                change: true,
            },

            referFriend: true,
            referFriendMedia: true,
            profileModal: true,
            authCheck: true,
            awards: true,
            transfers: true,
        },

        has: {
            emailLoginError: true,
            information: true,
            fcmToken: true,
            updateError: true,
            logoutError: true,
            followed: true,
            unfollowed: true,
            blocked: true,
            unblocked: true,
            changed: {
                onlineStatus: true,
            },
            chatInitiatedOrderError: true,
            initiatedChatOrder: true,
            registrationError: true,
        },

        profilePicture: {
            changed: true,

            needs: {
                change: true,
                storage: true,
                pictureForm: true,
            },

            has: {
                storageError: true,
            },
        },
    },

    location: {
        is: {
            needed: true,
            available: true,
            decoded: true,
        },
        needs: {
            decode: true,
        },
        has: {
            decodeError: true,
        },
    },

    map: {
        needs: {
            interface: true,
        },

        has: {
            location: true,
        },
    },

    order: {
        placed: true,
        repeated: true,
        cancelled: true,
        statusChanged: true,
        paymentRefunded: true,
        deleted: true,
        surplusClaimed: true,
        surplusPaid: true,

        needs: {
            history: true,
            placement: true,
            repeat: true,
            repeatForm: true,
            cancellation: true,
            cancellationReason: true,
            deletion: true,
            display: true,
            recentOrders: true,
            payment: true,
            catalog: true,
            filter: true,
            statusChange: true,
            massStatusChange: true,
            completionCode: true,
            trackInformation: true,
            paymentRefund: true,
            surplusComputation: true,
            processForm: true,
            refresh: true,

            to: {
                close: {
                    processForm: true,
                },
            },
        },

        has: {
            placementError: true,
            recentOrders: true,
            repeatError: true,
            completeHistory: true,
            catalog: true,
            statusChangeError: true,
            cancellationReason: true,
            cancellationError: true,
            deletionError: true,
        },

        is: {
            transferred: true,
        },
    },

    deliverer: {
        has: {
            arrived: true,
        },
        needs: {
            orderStatus: true,
            allDeliverers: true,
            to: {
                transferOrder: true,
            },
        },
    },

    review: {
        stored: true,
        updated: true,
        deleted: true,

        needs: {
            creation: true,
            update: true,
            deletion: true,
            reviewForm: true,
            storage: true,
        },

        has: {
            storageError: true,
        },
    },

    appReview: {
        needs: {
            prompt: true,
            rateNow: true,
            remindLater: true,
        },

        shown: true,
        dismissed: true,
    },

    homescreenGuide: {
        needs: {
            // Show the "Add to Home Screen" steps modal (iOS).
            prompt: true,
        },
    },

    businessRating: {
        needs: {
            // Show the "rate the businesses in your last order" modal.
            // Payload: { order, items }
            prompt: true,
            // Submit a rating for a single order item's business.
            // Payload: { orderItemId, companyId, rating }
            rateItem: true,
        },

        itemRated: true,
        itemRatingFailed: true,
        shown: true,
        dismissed: true,
    },

    featureAnnouncements: {
        needs: {
            // Queue up (and show, if nothing is currently showing) one or
            // more "what's new" feature-announcement walkthroughs.
            // Payload: { featureAnnouncements }
            prompt: true,
        },

        shown: true,
        dismissed: true,
    },

    deliveryAddress: {
        chosen: true,
        selected: true,
        stored: true,
        deleted: true,

        needs: {
            deletion: true,
            addressForm: true,
            storage: true,
            allAddresses: true,
            addressList: true,
            closeAddressList: true,
        },

        has: {
            storageError: true,
            deletionError: true,
            allAddresses: true,
        },
    },

    voiceOrderCall: {
        needs: {
            start: true,
            end: true,
        },

        has: {
            statusChanged: true,
            transcript: true,
            toolCalled: true,
            heartbeat: true,
            audioLevel: true,
            ended: true,
            error: true,
        },
    },

    deliveryRequest: {
        stored: true,
        deleted: true,

        needs: {
            deletion: true,
            requestForm: true,
            closeRequestForm: true,
            storage: true,
            allRequests: true,
            estimateFee: true,
        },

        has: {
            storageError: true,
            deletionError: true,
            allRequests: true,
            estimatedFee: true,
            estimateError: true,
        },
    },

    typicalProduct: {
        needs: {
            view: true,
        },
    },

    product: {
        stored: true,
        deleted: true,

        display: {
            need: {
                close: true,
            },
        },

        needs: {
            deletion: true,
            customerCatalog: true,
            creation: true,
            productForm: true,
            storage: true,
            allItems: true,
            update: true,
            share: true,
            save: true,
            like: true,
            unlike: true,
            bookmark: true,
            bookmarkRemoved: true,
            comment: true,
            commentForm: true,
            display: true,

            to: {
                saveComment: true,
            },
        },

        has: {
            storageError: true,
            allItems: true,
            deletionError: true,
            likeError: true,
            bookmarkError: true,
            commentError: true,
        },

        is: {
            liked: true,
            unliked: true,
            bookmarked: true,
            notBookmarked: true,
            commented: true,
        },
    },

    userProduct: {
        needs: {
            addForm: true,
            progressForm: true,
        },
    },

    cart: {
        itemSelected: true,
        itemAdded: true,
        itemUpdated: true,

        needs: {
            itemRemoval: true,
            itemAddition: true,
            allItems: true,
            itemUpdate: true,
            itemUpdateForm: true,
            productUpdate: true,
        },

        has: {
            additionError: true,
            allItems: true,
            updateError: true,
        },
    },

    payment: {
        stored: true,
        failed: true,
        completed: true,

        needs: {
            creation: true,
            collection: true,
        },

        has: {
            processingError: true,
        },
    },

    paymentRequest: {
        stored: true,
        deleted: true,

        needs: {
            allRequests: true,
            payment: true,
            creation: true,
            storage: true,
            requestForm: true,
            deletion: true,
        },

        has: {
            allRequests: true,
            storageError: true,
            deletionError: true,
        },
    },

    purchase: {
        stored: true,
        completed: true,
        failed: true,

        needs: {
            creation: true,
            form: true,
            storage: true,
            confirmation: true,
            display: true,
            refresh: true,
        },

        has: {
            storageError: true,
            completionError: true,
            displayError: true,
            refreshError: true,
        },

        is: {
            confirming: true,
            refreshing: true,
        },
    },

    analytics: {
        needs: {
            event: true,
        },
    },

    capa: {
        deposited: true,
        transferred: true,
        withdrawn: true,

        needs: {
            deposit: true,
            depositForm: true,
            withdrawForm: true,
            purchase: true,
            payment: true,
            balance: true,
            transfer: true,
            transferForm: true,
            to: {
                initiateTransfer: true,
                initiateWithdraw: true,
            },
        },

        is: {
            depositing: true,
        },

        has: {
            depositError: true,
            balance: true,
            transferError: true,
            withdrawError: true,
        },
    },

    surplus: {
        claimed: true,
        reimbursed: true,
        customerReimbursed: true,
        reimbursementCompleted: true,
        reimbursementFailed: true,

        needs: {
            claim: true,
            negativeReimbursement: true,
            positiveReimbursement: true,
            processReimbursement: true,
            form: true,
        },

        has: {
            claimError: true,
            reimbursementError: true,
        },

        is: {
            confirming: true,
        },
    },

    setting: {
        updated: true,

        needs: {
            information: true,
            update: true,
        },

        has: {
            information: true,
        },
    },

    qr: {
        needs: {
            scan: true,
            creation: true,
            scanForm: true,
            resultHandling: true,
            code: true,
        },

        has: {
            visibleForm: true,
            scanResult: true,
        },
    },

    comment: {
        deleted: true,

        is: {
            liked: true,
            unliked: true,
            repliedTo: true,
        },

        needs: {
            deletion: true,
            like: true,
            unlike: true,
            reply: true,
            replyForm: true,
            replies: true,

            to: {
                saveReply: true,
                hideReplies: true,
            },
        },

        has: {
            deletionError: true,
            reactionError: true,
            replyError: true,
        },
    },

    mention: {
        clicked: true,

        needs: {
            search: true,
            searchForm: true,
        },

        has: {
            value: true,
        },
    },

    image: {
        needs: {
            view: true,
        },
    },

    hashtag: {
        location: {
            stored: true,

            needs: {
                storage: true,
            },

            has: {
                storageError: true,
            },
        },
    },

    errand: {
        task: {
            needs: {
                completion: true,
                completionForm: true,
            },
            has: {
                completionError: true,
            },
            is: {
                completed: true,
            },
        },

        is: {
            requested: true,
        },

        needs: {
            request: true,
            creation: true,

            to: {
                removeTask: true,
            },
        },
        has: {
            requestError: true,
        },
    },

    announcement: {
        was: {
            clicked: true,
        },
    },

    chatInitiatedOrder: {
        needs: {
            confirmationForm: true,
        },

        is: {
            confirmed: true,
        },

        has: {
            responseError: true,
            confirmation: true,
        },
    },

    aiCredit: {
        deposited: true,

        needs: {
            deposit: true,
            depositForm: true,
            purchase: true,
            payment: true,
            balance: true,
        },

        is: {
            depositing: true,
        },

        has: {
            depositError: true,
            balance: true,
        },
    },

    subscription: {
        cancelled: true,
        needs: {
            active: true,
            plans: true,
            closePlans: true,
            subscribe: true,
            cancel: true,
        },
        has: {
            active: true,
            plans: true,
        },
    },

    companyBookmark: {
        needs: {
            list: true,
            toggle: true,
        },

        is: {
            bookmarked: true,
            notBookmarked: true,
        },

        has: {
            list: true,
            toggleError: true,
        },
    },

    termsAndConditions: {
        accepted: true,
        declined: true,

        needs: {
            acceptance: true,
        },
    },
};
